module.exports = __webpack_public_path__ + "img/Certificates.1c89b382.svg";